import { Behavior } from '../../behavior';
import { BehaviorContext } from '../../behavior-context';
import { InputModel } from 'projects/grit-core/src/lib/pg-field/pg-input-factory/input-model';
import { PgInputFactoryComponent } from 'projects/grit-core/src/lib/pg-field/pg-input-factory/pg-input-factory.component';
import { PgInputDirective } from 'projects/grit-core/src/lib/pg-field/pg-input/pg-input.directive';
import { Injectable } from '@angular/core';

// import { BehaviorContext } from '../../behavior-context';
// import { PgInputDirective } from '@progleasing/style';

// import { InputModel } from '../../../../models/input-model';
// import { PgInputFactoryComponent } from 'projects/component-factory/src/lib/ui-factories/components/pg-input-factory/pg-input-factory.component';
// import { Behavior } from '../../behavior';

// /**
//  *
//  * Attach this script to a suffix icon that will enable a field for edit on click
//  */
// export function iconEditDisabledField(context: BehaviorContext) {
//   if (!context.parent) {
//     throw new Error(
//       'editDisabledField requires a context.parent of type PgInputFactoryComponent'
//     );
//   }
//   if (!context.parentModel) {
//     throw new Error(
//       'editDisabledField requires a context.parentModel InputModel'
//     );
//   }

//   const input: PgInputDirective = (context.parent as PgInputFactoryComponent)
//     .input;
//   const inputModel: InputModel = context.parentModel;

//   // const blurSubscription: Subscription = input.stateChanges.subscribe(() => {
//   //   inputModel.disabled = true;
//   //   blurSubscription.unsubscribe();
//   // });

//   inputModel.disabled = false;

//   setTimeout(() => {
//     input.focus(0, 0);
//   }, 1);

//   // Hide the icon
//   context.targetModel.hidden = true;
// }

@Injectable()
export class IconEditDisabledField implements Behavior {
  async execute(
    args: { [key: string]: any },
    context: BehaviorContext
  ): Promise<any> {
    const input: PgInputDirective = (context.target as PgInputFactoryComponent)
      .input;
    const inputModel: InputModel = context.target.model;

    // const blurSubscription: Subscription = input.stateChanges.subscribe(() => {
    //   inputModel.disabled = true;
    //   blurSubscription.unsubscribe();
    // });

    inputModel.disabled = false;

    setTimeout(() => {
      input.focus(0, 0);
    }, 1);
  }
}
